
// import { useNavigate } from "react-router-dom";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, Navigation } from "swiper/modules";
// import { motion } from "framer-motion";

// import bannergame from '../assest/products/extra/bannergame.jpg';
// import bannerrefurbished from '../assest/products/extra/bannerrefurbished.webp';
// import bannerbusiness from '../assest/products/extra/bannerbusiness.png';
// import bannerlap from '../assest/products/extra/bannerlap.png';
// import banner from '../assest/products/extra/banner.jpg';

// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";

// const BannerCarousel = () => {

//   const navigate = useNavigate();

//   const banners = [
//     {
//       img: banner,
//       link: "/product-category?category=laptops"
//     },
//     {
//       img: bannergame,
      
//       link: "/product-category?category=gaming-laptops"
//     },
//     {
//       img: bannerbusiness,
    
//       link: "/product-category?category=business-laptops"
//     },
//     {
//       img: bannerlap,
//       // title: "Student Deals",
//       // subtitle: "Affordable Laptops for Study",
//       link: "/product-category?category=study-laptops"
//     },
//     {
//       img: bannerrefurbished,
//       // title: "Apple Refurbished",
//       // subtitle: "MacBooks at Best Prices",
//       link: "/product-category?brand=apple"
//     }
//   ];

//   return (
//     <div className="w-full">

//       <Swiper
//         modules={[Autoplay, Pagination, Navigation]}
//         autoplay={{ delay: 4000, disableOnInteraction: false }}
//         loop={true}
//         pagination={{ clickable: true }}
//         navigation={true}
//         className="w-full aspect-[16/7] sm:aspect-[16/6] md:aspect-[16/5] lg:aspect-[16/7]"
//       >

//         {banners.map((banner, index) => (
//           <SwiperSlide key={index}>

//             <div className="relative w-full h-full overflow-hidden group">

//               {/* IMAGE */}
//               <img
//                 src={banner.img}
//                 alt="banner"
//                 className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
//               />

//               {/* OVERLAY */}
//               {/* <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent" /> */}

//               {/* CONTENT */}
//               <div className="absolute inset-0 flex items-center">

//                 <div className="container mx-auto px-4 md:px-10 text-white max-w-xl">

//                   {banner.title && (
//                     <motion.h1
//                       initial={{ opacity: 0, y: 40 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ duration: 0.6 }}
//                       className="text-xl sm:text-3xl md:text-5xl font-bold leading-tight"
//                     >
//                       {banner.title}
//                     </motion.h1>
//                   )}

//                   {banner.subtitle && (
//                     <motion.p
//                       initial={{ opacity: 0, y: 40 }}
//                       animate={{ opacity: 1, y: 0 }}
//                       transition={{ delay: 0.2 }}
//                       className="mt-2 text-sm md:text-lg text-gray-200"
//                     >
//                       {banner.subtitle}
//                     </motion.p>
//                   )}

//                   {/* <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                     onClick={() => navigate(banner.link)}
//                     className="mt-4 md:mt-6 bg-blue-600 hover:bg-blue-700 px-4 md:px-6 py-2 md:py-3 rounded-lg text-sm md:text-base shadow-lg transition"
//                   >
//                     Shop Now →
//                   </motion.button> */}

//                 </div>

//               </div>

//             </div>

//           </SwiperSlide>
//         ))}

//       </Swiper>

//     </div>
//   );
// };

// export default BannerCarousel;

import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

import bannergame from '../assest/products/extra/bannergame.jpg';
import bannergameMobile from '../assest/products/extra/m1.webp';

import bannerrefurbished from '../assest/products/extra/bannerrefurbished.webp';
import bannerrefurbishedMobile from '../assest/products/banner/m1.png';

import bannerbusiness from '../assest/products/banner/banner5.webp';
import bannerbusinessMobile from '../assest/products/banner/m2.png';

import bannerlap from '../assest/products/extra/bannerlap.png';
import bannerlapMobile from '../assest/products/extra/m2.avif';

import banner from '../assest/products/extra/banner.jpg';
import bannerMobile from '../assest/products/banner/m3.png';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const BannerCarousel = () => {

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  // 🔥 detect screen size
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const banners = [
    {
      desktop: banner,
      mobile: bannerMobile,
      link: "/product-category?category=laptops"
    },
    {
      desktop: bannergame,
      mobile: bannergameMobile,
      link: "/product-category?category=gaming-laptops"
    },
    {
      desktop: bannerbusiness,
      mobile: bannerbusinessMobile,
      link: "/product-category?category=business-laptops"
    },
    {
      desktop: bannerlap,
      mobile: bannerlapMobile,
      link: "/product-category?category=study-laptops"
    },
    {
      desktop: bannerrefurbished,
      mobile: bannerrefurbishedMobile,
      link: "/product-category?brand=apple"
    }
  ];

  return (
    <div className="w-full">

      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop
        pagination={{ clickable: true }}
        navigation
        className={`
          w-full 
          ${isMobile 
            ? "h-[78vh]"   // 🔥 mobile full screen feel
            : "aspect-[16/6] lg:aspect-[16/7]"
          }
        `}
      >
 
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>

            <div
              onClick={() => navigate(banner.link)}
              className="relative w-full h-full cursor-pointer overflow-hidden group"
            >

              {/* 🔥 IMAGE SWITCH */}
              <motion.img
                key={isMobile ? banner.mobile : banner.desktop}
                src={isMobile ? banner.mobile : banner.desktop}
                initial={{ scale: 1.1, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="w-full h-full object-cover object-center"
              />

              {/* 🔥 HOVER ZOOM */}
              <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-105" />


              {/* 🔥 CONTENT ANIMATION */}
              <div className="absolute inset-0 flex items-center">

                <div className="container mx-auto px-4 md:px-10 text-white max-w-xl">


                </div>

              </div>

            </div>

          </SwiperSlide>
        ))}

      </Swiper>

    </div>
  );
};

export default BannerCarousel;

